import { OptionsStackingValue } from 'highcharts';
import { BaseChartProps } from '../types';
import { ChartType, ChartTypes } from '../types/charts';
import { supportsMultipleYAxis } from './axisUtils';
import { OPTIONS_STACKING_VALUES, PRIMARY_Y_AXIS_INDEX } from './constants';

export const stackingChartTypes = [ChartTypes.Bar];

export function isStackingChartType(chartType: string | null): boolean {
  if (chartType === null) {
    return false;
  }
  return stackingChartTypes.includes(chartType as ChartType);
}

export const isValidStackingValue = (value: unknown): value is OptionsStackingValue => {
  return typeof value === 'string' && OPTIONS_STACKING_VALUES.includes(value as OptionsStackingValue);
};

export const getStackingValue = (params: BaseChartProps) => {
  let stackingValue = params.stacking;
  if (supportsMultipleYAxis(params.yAxis)) {
    const primaryYAxisConfig = params.yAxis[PRIMARY_Y_AXIS_INDEX];
    stackingValue = primaryYAxisConfig?.stacking; // get the stacking value from the primary yAxis config
  }
  return isValidStackingValue(stackingValue) ? stackingValue : 'normal';
};
